import { useEffect, useRef } from "react";

/**
 * AdSense responsive slot for the top of the home page (under the logo).
 * Slot ID: 5328244643
 */
export default function HomeTopAdSense() {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {}
  }, []);

  return (
    <div className="relative z-10 w-full max-w-3xl mx-auto px-4 mt-4">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-9843677136046770"
        data-ad-slot="5328244643"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
